import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';

export interface RiskGroupStateModel {
  riskGroup: any;
}

@State<RiskGroupStateModel>({
  name: 'riskGroupState',
  defaults: {
    riskGroup: {}
  }
})
@Injectable()
export class RiskGroupState {
  constructor() {}

  //******* SELECTORS *********

  @Selector()
  static riskGroups(state: RiskGroupStateModel) {
    let result: any = [];
    for (var i in state.riskGroup) {
      result.push(state.riskGroup[i]);
    }
    return result;
  }

  @Selector()
  static riskGroupsCodes(state: RiskGroupStateModel) {
    let result: any = [];
    for (var i in state.riskGroup) {
      result.push({ Code: state.riskGroup[i].RiskGroup_Code, Code_Desc: state.riskGroup[i].RiskGroup_Code });
    }
    return result;
  }

  //******  ACTIONS  ******
}
